import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import PortableText from "./portableText";
import Button from "./button";

import * as styles from "../styles/components/fc-copy-block.module.css";

interface ButtonType {
  blank?: boolean;
  text?: string;
  url?: string;
}

interface CopyBlockProps {
  title?: string;
  _rawCopy?: any[];
  button?: ButtonType;
}

const CopyBlock: React.FC<CopyBlockProps> = ({
  title,
  _rawCopy,
  button
}) => {
  if (!title && !_rawCopy) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        <div className={cn("grid", styles.grid)}>
          {title && (
            <div className="col-lg-7">
              <h2 className={cn("h4", styles.title)}>{title}</h2>
            </div>
          )}

          {(_rawCopy || button?.url) && (
            <div className="col-lg-5 offset-lg-7">
              <div className={styles.wrap}>
                {_rawCopy && (
                  <div className={cn("entry-content", styles.copy)}>
                    <PortableText blocks={_rawCopy} />
                  </div>
                )}
                <Button node={button} />
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default CopyBlock;
